function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "columns_svg__cls-1",
  d: "M17.65 14.59a1.7 1.7 0 01-1.7 1.7H1.7a1.7 1.7 0 01-1.7-1.7V1.69a1.7 1.7 0 011.7-1.7h14.25a1.7 1.7 0 011.7 1.7v12.89zm-9.5.34V2.71H1.36v11.88a.35.35 0 00.34.34h6.45zm8.14-12.22H9.5v12.22h6.45a.35.35 0 00.34-.34V2.71z"
});

var SvgColumns = function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 17.65 16.29"
  }, props), _ref);
};

export default SvgColumns;